function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => updateItem(data_line,0));
       addToCartAndUpdateDrawer();
    });
    
    document.querySelectorAll('.header-cart a').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.add('open-drawer');
        const button = document.querySelector('.custom-note .cn-btn');
          if (button) {
              button.addEventListener('click', function() {
                  const accordionContent = this.closest('.custom-note').querySelector('.cn-con');
                  const textarea = accordionContent.querySelector('textarea');
          
                  this.classList.toggle('active_note');
                  if (this.classList.contains('active_note')) {
                      accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';

                    if (textarea) {
                      setTimeout(() => textarea.focus(), 300); 
                  }
                    
                  } else {
                      accordionContent.style.maxHeight = 0;
                  }
              });
          }
        addToCartAndUpdateDrawer();
 
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-wishlist');
      });
    });
    
    document.querySelectorAll('.overlay-box,.cart-drawer-close a').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-wishlist','open-account','active-login','active-register');
      });
    });
    document.querySelectorAll('.ci_plus a').forEach(function(plus) {
      plus.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
        input.value = parseInt(input.value) + 1;
        var new_line = this.getAttribute('data-line-item');
        var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        updateItem(new_line, new_qty);
      });
    });
    document.querySelectorAll('.ci_minus a').forEach(function(minus) {
      minus.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
        var currentQty = parseInt(centerQtyInput.value);
        if(currentQty > 0){
          centerQtyInput.value = currentQty - 1;
          var newLine = this.getAttribute('data-line-item');
          var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
          updateItem(newLine, newQty);
        }
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(document.querySelectorAll('.item-row[data-properties]').length > 0){
        document.querySelector('.cart-bubble').innerHTML = cart_count - document.querySelectorAll('.item-row[data-properties]').length;
      }else{
        document.querySelector('.cart-bubble').innerHTML = cart_count;
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
  
}
load_cart();
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
          
          const button = document.querySelector('.custom-note .cn-btn');
            if (button) {
                button.addEventListener('click', function() {
                    const accordionContent = this.closest('.custom-note').querySelector('.cn-con');
            
                    this.classList.toggle('active_note');
                    if (this.classList.contains('active_note')) {
                        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
                    } else {
                        accordionContent.style.maxHeight = 0;
                    }
                });
            }
         addToCartAndUpdateDrawer();
        },500);
      }else{
        window.location.href = "/cart";
      }         
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


function addToCartAndUpdateDrawer() {
document.querySelectorAll('.w-com-add').forEach((productAddCart) => {
  productAddCart.addEventListener('click',function(evt){
    const productContainer = this.closest('.w-com-con');
    const varId = productContainer.getAttribute('var');
    
    const data = new FormData();
    data.append("id", varId);
    data.append("quantity", 1);

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
    .then(response => response.json())
    .then(() => {
      load_cart();
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    })
    .finally(() => {
      // addButton.classList.remove("loading");
      // addButton.disabled = false;
    });
  });
});
}


